//GETTERS
export const GET_MASSIVE_DEPENDENTS_INCORPORATION_URL =
  'massiveIncorporation/GET_MASSIVE_DEPENDENTS_INCORPORATION_URL';
export const GET_OPTIONAL_FILES_DEPENDENTS_TICKET_GROUP =
  'massiveIncorporation/GET_OPTIONAL_FILES_DEPENDENTS_TICKET_GROUP';

//SETTERS
export const SET_MASSIVE_DEPENDENTS_INCORPORATION_URL =
  'massiveIncorporation/SET_MASSIVE_DEPENDENTS_INCORPORATION_URL';
export const SET_OPTIONAL_FILES_DEPENDENTS_TICKET_GROUP =
  'massiveIncorporation/SET_OPTIONAL_FILES_DEPENDENTS_TICKET_GROUP';

//ACTIONS
export const FETCH_MASSIVE_DEPENDENTS_INCORPORATION_URL =
  'massiveIncorporation/FETCH_MASSIVE_DEPENDENTS_INCORPORATION_URL';
export const POST_FILE_DEPENDENTS_INCORPORATION =
  'massiveIncorporation/POST_FILE_DEPENDENTS_INCORPORATION';
export const FETCH_OPTIONAL_FILES_DEPENDENTS_TICKET_GROUP =
  'massiveIncorporation/SET_OPTIONAL_FILES_DEPENDENTS_TICKET_GROUP';
export const POST_MASSIVE_FORM_DEPENDENTS_INCORPORATION =
  'massiveIncorporation/POST_MASSIVE_FORM_DEPENDENTS_INCORPORATION';
export const POST_NO_DELIVERABLE_DEPENDENTS_INCORPORATION =
  'massiveIncorporation/POST_NO_DELIVERABLE_DEPENDENTS_INCORPORATION';
